export const preliminaryOperatorCalculationConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_PRELIMINARY_OPERATOR_CALCULATION_SUCCESS',
		REQUEST : 'GET_PAGED_PRELIMINARY_OPERATOR_CALCULATION_REQUEST',
		FAILURE : 'GET_PAGED_PRELIMINARY_OPERATOR_CALCULATION_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_PRELIMINARY_OPERATOR_CALCULATION_REQUEST',
		SUCCESS : 'CREATE_PRELIMINARY_OPERATOR_CALCULATION_SUCCESS',
		FAILURE : 'CREATE_PRELIMINARY_OPERATOR_CALCULATION_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_PRELIMINARY_OPERATOR_CALCULATION_REQUEST',
		SUCCESS : 'DELETE_PRELIMINARY_OPERATOR_CALCULATION_SUCCESS',
		FAILURE : 'DELETE_PRELIMINARY_OPERATOR_CALCULATION_FAILURE'
	},
	CLEAR: 'CLEAR_PRELIMINARY_OPERATOR_CALCULATION'
}